import { render, staticRenderFns } from "./CollapsedContentLayout.vue?vue&type=template&id=f9b391ea&scoped=true&"
import script from "./CollapsedContentLayout.vue?vue&type=script&lang=js&"
export * from "./CollapsedContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./CollapsedContentLayout.vue?vue&type=style&index=0&id=f9b391ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b391ea",
  null
  
)

export default component.exports